import VueI18n from 'vue-i18n'

export default new VueI18n({
    locale: window['w2p_second_language'] ? 'second' : 'de',
    messages: {
        de: {
            objectsList: {
                heading: 'Personalisierung'
            },
            configurationProperty: {
                text: 'Text',
                image: 'Bild hochladen',
                galleryImage: 'Motiv auswählen',
                fontColor: 'Schriftfarbe',
                fontSize: 'Schriftgröße',
                fontFamily: 'Schriftart',
                fontAlign: 'Textausrichtung',
                height: 'Höhe (in mm)',
                width: 'Breite (in mm)',
                maxWidth: 'Maximale Breite (in mm)',
                top: 'y-Position (in mm)',
                left: 'x-Position (in mm)',
                angle: 'Winkel',
                positionLimits: {
                    left: 'links',
                    top: 'oben',
                    right: 'rechts',
                    bottom: 'unten',
                    min: 'min',
                    max: 'max'
                }
            },
            elementTypes: {
                headings: {
                    'text': 'Textelement',
                    'image': 'Druckdatei'
                }
            },
            formElements: {
                imageUpload: {
                    label: window['w2p_language_imageUpload_label'] ? window['w2p_language_imageUpload_label'] : 'Wähle ein Bild...'
                },
                imageRemoveBtn: {
                    label: window['w2p_language_imageRemoveBtn_label'] ? window['w2p_language_imageRemoveBtn_label'] : 'Bild entfernen'
                },
                addToBasket: {
                    label: window['w2p_language_addToBasket_label'] ? window['w2p_language_addToBasket_label'] : 'In den Warenkorb'
                },
                showOnWishList: {
                    label: window['w2p_language_showOnWishList_label'] ? window['w2p_language_showOnWishList_label'] : 'Auf Merkzettel speichern'
                }
            }
        },
        second: {
            objectsList: {
                heading: 'Personalization'
            },
            configurationProperty: {
                text: 'Text',
                image: 'Upload Image',
                galleryImage: 'Select Image',
                fontColor: 'Font Color',
                fontSize: 'Font Size',
                fontFamily: 'Font Family',
                fontAlign: 'Test Alignment',
                height: 'Height (in mm)',
                width: 'Width (in mm)',
                maxWidth: 'Maximum Width (in mm)',
                top: 'y-Position (in mm)',
                left: 'x-Position (in mm)',
                angle: 'Angle',
                positionLimits: {
                    left: 'left',
                    top: 'top',
                    right: 'right',
                    bottom: 'bottom',
                    min: 'min',
                    max: 'max'
                }
            },
            elementTypes: {
                headings: {
                    'text': 'Textelement',
                    'image': 'Printfile'
                }
            },
            formElements: {
                imageUpload: {
                    label: window['w2p_language_imageUpload_label'] ? window['w2p_language_imageUpload_label'] : 'Choose an image...'
                },
                imageRemoveBtn: {
                    label: window['w2p_language_imageRemoveBtn_label'] ? window['w2p_language_imageRemoveBtn_label'] : 'Remove image'
                },
                addToBasket: {
                    label: window['w2p_language_addToBasket_label'] ? window['w2p_language_addToBasket_label'] : 'Add to shopping cart'
                },
                showOnWishList: {
                    label: window['w2p_language_showOnWishList_label'] ? window['w2p_language_showOnWishList_label'] : 'Save to wish list'
                }
            }
        }
    }
});